<template>
  <svg class="icon" viewBox="0 0 1024 1024" :width="size" :height="size">
    <path d="M896 470.4a41.6 41.6 0 0 1 41.152 35.456L937.6 512v320a41.6 41.6 0 0 1-35.456 41.152L896 873.6H128a41.6 41.6 0 0 1-41.152-35.456L86.4 832V512a41.6 41.6 0 0 1 82.752-6.144L169.6 512v278.4h684.8V512a41.6 41.6 0 0 1 35.456-41.152L896 470.4zM535.104 118.784l4.672 4.032 181.056 180.992a41.6 41.6 0 0 1-54.208 62.912l-4.672-4.032L553.6 254.272v397.12a41.6 41.6 0 0 1-82.752 6.144l-0.448-6.144V250.944L358.784 362.688a41.6 41.6 0 0 1-54.208 4.032l-4.608-4.032a41.6 41.6 0 0 1-4.032-54.208l4.032-4.672L480.96 122.88a41.6 41.6 0 0 1 54.144-4.032z"></path>

  </svg>
</template>

<script>
export default {
  props: {
    size: {
      default: '24'
    }
  }
}
</script>
